var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalaryGrayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1968_25462",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0V20H20V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1968_25462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1641 17.7077H5.83073C2.78906 17.7077 1.03906 15.9577 1.03906 12.916V7.08268C1.03906 4.04102 2.78906 2.29102 5.83073 2.29102H14.1641C17.2057 2.29102 18.9557 4.04102 18.9557 7.08268V12.916C18.9557 15.9577 17.2057 17.7077 14.1641 17.7077ZM5.83073 3.54102C3.4474 3.54102 2.28906 4.69935 2.28906 7.08268V12.916C2.28906 15.2993 3.4474 16.4577 5.83073 16.4577H14.1641C16.5474 16.4577 17.7057 15.2993 17.7057 12.916V7.08268C17.7057 4.69935 16.5474 3.54102 14.1641 3.54102H5.83073Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 13.125C8.275 13.125 6.875 11.725 6.875 10C6.875 8.275 8.275 6.875 10 6.875C11.725 6.875 13.125 8.275 13.125 10C13.125 11.725 11.725 13.125 10 13.125ZM10 8.125C8.96667 8.125 8.125 8.96667 8.125 10C8.125 11.0333 8.96667 11.875 10 11.875C11.0333 11.875 11.875 11.0333 11.875 10C11.875 8.96667 11.0333 8.125 10 8.125Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8281 6.45703H13.3281C12.9865 6.45703 12.7031 6.1737 12.7031 5.83203C12.7031 5.49036 12.9865 5.20703 13.3281 5.20703H15.8281C16.1698 5.20703 16.4531 5.49036 16.4531 5.83203C16.4531 6.1737 16.1698 6.45703 15.8281 6.45703Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66406 14.791H4.16406C3.8224 14.791 3.53906 14.5077 3.53906 14.166C3.53906 13.8243 3.8224 13.541 4.16406 13.541H6.66406C7.00573 13.541 7.28906 13.8243 7.28906 14.166C7.28906 14.5077 7.00573 14.791 6.66406 14.791Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalaryGrayIcon);
export default __webpack_public_path__ + "static/media/salary_gray_icon.336e0ac36e17da8f3fcf685b7275aed2.svg";
export { ForwardRef as ReactComponent };